/*************************************************/
/* SEARCH                                        */
/*************************************************/

export function search() {
    const suggestionsSelector = ".search-suggestions";
    const searchFormSelector = ".search-form";
    var typeTimer;

    const getAndDisplaySearchResults = function (query) {
        var endpointUrl = $(searchFormSelector).attr("action");
        $.get(endpointUrl + "?altTemplate=searchSuggestions&q=" + query).done(function (data) {
            $(searchFormSelector).append(data);
            $(suggestionsSelector).show();
        });
    };

    const init = function () {

        $(searchFormSelector + " input").on("keyup",
            function () {
                if ($(searchFormSelector).attr("data-show-suggestions") === "False") return;
                $(suggestionsSelector).remove();
                const query = $(this).val();
                clearTimeout(typeTimer);
                typeTimer = setTimeout(function () { getAndDisplaySearchResults(query); }, 500);
            });

        $(document).on("click",
            function (e) {
                const clickTarget = $(e.target);
                let searchResultBox = $(suggestionsSelector);
                if (searchResultBox.length > 0 && clickTarget !== searchResultBox && clickTarget.closest(suggestionsSelector).length === 0) {
                    searchResultBox.remove();
                }
            });
    };

    init();
}